import { jwtDecode } from "jwt-decode";

interface DecodedToken {
  email: string;
  exp: number;
  user_id: number;
  username: string;
  tis_session: string;
}

export function decodeToken(
  token: string = localStorage.getItem("jwtToken")
): DecodedToken | never {
  const decodedToken = jwtDecode<DecodedToken>(token);
  return decodedToken;
}
